import React from 'react';
import EditJobPreferences from './EditJobPreferences';
import { GridCellParams } from '@mui/x-data-grid-pro';

const EditJobPreferencesGridCell = (params: GridCellParams) => {
  const displayText = params?.row?.preferenceSetName;
  const preferenceId = params?.row?.id;
  return (
    <div>
      <EditJobPreferences displayText={displayText} id={preferenceId} />
    </div>
  );
};

export default EditJobPreferencesGridCell;
